
const FinOpsHelp = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          FinOps Dashboard
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          The FinOps dashboard provides comprehensive AWS cost tracking, budget management, and financial
          optimization insights. Monitor spending trends, identify cost anomalies, and optimize your cloud
          infrastructure costs across all connected environments.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Cost Tracking
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Monitor AWS costs with data synced every 6 hours from AWS Cost Explorer.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Total Spend:</strong> Current month costs and variance vs. previous periods</li>
          <li><strong>Daily Costs:</strong> Granular daily spending breakdown</li>
          <li><strong>Service Breakdown:</strong> Costs by AWS service (EC2, S3, RDS, etc.)</li>
          <li><strong>Region Distribution:</strong> Spending by AWS region</li>
          <li><strong>Account Filtering:</strong> View costs per AWS account or environment</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Budget Management
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Set and track budgets to prevent cost overruns and receive alerts.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Budget Thresholds:</strong> Define monthly, quarterly, or annual spending limits</li>
          <li><strong>Burn Rate:</strong> Current spending rate compared to budget allocation</li>
          <li><strong>Forecasting:</strong> Projected end-of-period costs based on trends</li>
          <li><strong>Alerts:</strong> Notifications when spending exceeds defined thresholds</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Cost Allocation by Tags
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Track costs by project, team, or custom tags for detailed cost attribution.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Tag-Based Filtering:</strong> View costs grouped by specific tag values</li>
          <li><strong>Project Costs:</strong> Track infrastructure costs per project</li>
          <li><strong>Team Attribution:</strong> Allocate costs to specific teams or departments</li>
          <li><strong>Service Breakdown by Tag:</strong> See which services drive costs for each tag</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Cost Optimization
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Identify opportunities to reduce costs through resource optimization.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Idle Resources:</strong> Detect underutilized or unused resources</li>
          <li><strong>Right-Sizing:</strong> Recommendations for optimally sized instances</li>
          <li><strong>Reserved Instances:</strong> Suggestions for RI purchases to reduce costs</li>
          <li><strong>Spot Instances:</strong> Opportunities to use spot instances for workloads</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Data Synchronization
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Cost data is automatically synced from AWS Cost Explorer.
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Sync Frequency:</strong> Costs updated every 6 hours</li>
          <li><strong>Historical Data:</strong> Access to up to 13 months of cost history</li>
          <li><strong>Cross-Account:</strong> Aggregates costs across all linked AWS accounts</li>
          <li><strong>Last Sync:</strong> Timestamp showing when data was last updated</li>
        </ul>
      </div>

    </>
  );
};

export default FinOpsHelp;
